export namespace UserLocationAction {
  export const setUserLocationToLocal = (cord: { lng: number; lat: number; placeId: string }) => {
    localStorage.setItem("userLocation", JSON.stringify(cord));
  };

  export const getUserLocationFromLocal = () => {
    const data = localStorage.getItem("userLocation");
    if (data) {
      return JSON.parse(data) as { lng: number; lat: number; placeId: string };
    } else {
      return null;
    }
  };
}
